import { Color } from "@swimlane/ngx-charts";
import { IPieChartData } from "../interfaces/IPieChartData";

export class GoldBuyPlan implements IPieChartData {
    public label!: string;
    public view!: [number, number];
    public scheme!: string | Color;
    public result!: any;
    public select: any;
    public PAO100:number = 0;
    public PAO250:number = 0;
    public PAO500:number = 0;
    public PAO1000:number = 0;
    public TotBalanceGrGold:number = 214;
}
